<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
  <div class="navbar-brand mr-auto">Coatings Security Cameras</div>
  <div>
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" href="/view">Home</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="logout()">Sign Out</a>
      </li>
    </ul>
  </div>
</nav>
<div class="container">
  <h3>Application Error</h3>
  <ngb-alert type="warning" [dismissible]="false">
    User
    <strong
      ><em>{{ appService.identity.upn }}</em></strong
    >
    is not registered in this application.
  </ngb-alert>
  <p>Please contact Coatings Application Support</p>
</div>
